import axios from "axios";
import jwt_decode from "jwt-decode";
import dayjs from "dayjs";

import { useContext } from "react";
import AuthContext from "../context/AuthContext";

const baseURL = "https://panelapi.budapester.com";

const useAxios = () => {
  const { authTokens, setUser, setAuthTokens } = useContext(AuthContext);

  const axiosInstance = axios.create({
    baseURL,
    headers: { Authorization: `Bearer ${authTokens?.token}` },
  });

  axiosInstance.interceptors.request.use(async (req) => {
    const user = jwt_decode(authTokens.token);
    const isExpired = dayjs.unix(user.exp).diff(dayjs()) < 1;

    if (!isExpired) return req;

    const response = await axios.post(`${baseURL}/refresh_token`, {
      refresh: authTokens.refresh_token,
    });

    localStorage.setItem("authTokens", JSON.stringify(response.data));

    setAuthTokens(response.data);
    setUser(jwt_decode(response.data.token));

    req.headers.Authorization = `Bearer ${response.data.token}`;
    return req;
  });

  return axiosInstance;
};

export default useAxios;
